import * as React from 'react';
import AxiosConfig from '../../utilities/AxiosConfig';
import axios from 'axios';
import SearchInput from '../../components/common/SearchInput';
import moment from 'moment';
import Checkbox from '../../components/common/checkbox';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Loader from '../../components/common/Loader';
import PTOStateCollapse from './PTOStateCollapse';
import { useDebounce } from '../../utilities/CustomHooks';
import MsalAuth from '../../utilities/msalAuth';
import UserSettings from '../../utilities/UserSettings';
import Tooltip from 'src/components/common/Dynamic-old/Tooltip';
import './PTOAdministration.css';
import { Form, OverlayTrigger, Popover } from 'react-bootstrap';
import { shouldAllowAccess } from 'src/utilities/helper';
import notificationStore from 'src/utilities/Notifications/notificationStore';
import { AppState } from 'src/store';
import { connect } from 'react-redux';

interface IProps {
    userId: string | number;
}

// const selectStyles: any = {
//     valueContainer: (provided: any, state: any): any => ({...provided, maxHeight: 40, overflow: "auto"})
// }

const currentYearStart: any = moment(new Date(new Date().getFullYear(), 0, 1));
let lastTenYears: Array<{ label: string, value: any }> = [];
for (let i = 0; i < 10; i++) {
    if (i === 0) {
        lastTenYears.push({ label: 'Current Year', value: currentYearStart });
    } else {
        let year = moment(currentYearStart).subtract(i, 'years');
        lastTenYears.push({
            label: `Year of ${year.format('YYYY')}`,
            value: year.valueOf()
        });
    }
}

const MODAL_VIEW = {
    DEFAULT: 'default', // not open
    INPUT: 'input',     // user input
    WARNING: 'warning', // end of year process warning
    STATUS: 'status'    // tells user the initial status of end of year archive
};

const PTOAdministration: React.FC<IProps> = (props: IProps) => {
    const [states, setStates] = React.useState([] as Array<any>);
    //r-18-lint-dj
    //eslint-disable-next-line
    const [profitCenter, setProfitCenter] = React.useState([] as Array<any>);
    const [reference, setReference] = React.useState({ states: [], profitCenters: [], departments: [], ptoPlans: [] } as any);
    const [showInactive, setShowInactive] = React.useState(false);
    const [searchValue, setSearchValue] = React.useState('');
    const debouncedSearchValue = useDebounce(searchValue, 800);
    //r-18-lint-dj
    //eslint-disable-next-line
    const [fromToDate, setFromToDate] = React.useState({ from: currentYearStart, to: moment(currentYearStart).add(1, "year") } as any);
    const [loading, setLoading] = React.useState(false as boolean);
    const [showOnlyPending, setShowOnlyPending] = React.useState(false);
    const [displayZeros, setDisplayZeros] = React.useState(false);
    //r-18-lint-dj
    //eslint-disable-next-line
    const [userSettings, setUserSettings] = React.useState(MsalAuth.UserSettings() || {});
    const [expandDetail, setExpandDetail] = React.useState(true);
    const [expandState, setexpandState] = React.useState(false);
    //r-18-lint-dj
    //eslint-disable-next-line
    const [expandCity, setExpandCity] = React.useState(false);

    const getReferenceData = () => {
        setLoading(true);
        const plansRequest: any = axios.get(process.env.REACT_APP_API_URL + "/api/pto/plans", AxiosConfig.configValue("min"))
        const referenceRequest: any = axios.get(process.env.REACT_APP_API_URL + "/api/pto/reference", AxiosConfig.configValue("min"))
        axios.all([plansRequest, referenceRequest]).then((responses) => {
            const plansResponse: any = responses[0];
            const referenceResponse: any = responses[1];
            const { states, profitCenters, departments, endOfYear } = referenceResponse.data;
            const newReference: any = { states, profitCenters, departments, endOfYear, ptoPlans: plansResponse.data };
            setReference(newReference);

            if (endOfYear.LastArchivedYear === 0) {     // This means there isn't a last archived year and the user will have to manually enter it
                setArchiveYearEditable(true);
            } else {
                setArchiveYearValue(endOfYear.LastArchivedYear + 1);    // + 1 to last archive year gets you the next year to be archived         
            }

            //cgm032322 for autoexpanding items if there is only one to improve user experience
            if (states.length === 1 && newReference.profitCenters.length === 1) {
                setexpandState(true);
                setExpandCity(true);
            } else if (states.length === 1) {
                setexpandState(true);
            }
            if (profitCenters.length === 1) {
                setExpandCity(true);

            }
            //? Adds all states and profitCenters to list
            if (states.length) {
                setStates(states.map((s: any) => ({ label: s.name, value: s.id })));
                // setState([{ label: states[0].name, value: states[0].id }]);
            }
            if (profitCenters.length) {
                setProfitCenter(profitCenters.map((p: any) => ({ label: p.name, value: p.id })));
                // setProfitCenter([{ label: profitCenters[0].name, value: profitCenters[0].id }])
            }
        })
            .catch(err => {
                //console.log(err, err.response);
            })
            .finally(() => { setLoading(false); });
    }

    // const handleStatesChange = (selected: any) => {
    //     let newSelection: any = selected ? selected : [];
    //     setStates(newSelection);
    //     let newProfitCenters: Array<any> = reference.profitCenters.filter((p: any) => newSelection.find((s: any) => s.value === p.stateId)) || [];
    //     setProfitCenter(newProfitCenters.map((p: any) => ({ label: p.name, value: p.id })));
    // }

    React.useEffect(() => {
        let settings = userSettings;
        if (userSettings.displayZeros) {
            setDisplayZeros(userSettings.displayZeros);
        }
        if ((settings.expandDetail) || (!("expandDetail" in settings))) {
            setExpandDetail(true)
        }
        else {
            setExpandDetail(false)
        }
        if (settings.showOnlyPending) {
            setShowOnlyPending(userSettings.showOnlyPending);
        }
        if (settings.showInactive) {
            setShowInactive(userSettings.showInactive)
        }
        getReferenceData();    
        //r-18-lint-dj
        //eslint-disable-next-line
    }, [])

    //cgm032422 for adding any boolean state item to the user Object for user convenience
    const handleOptionSelect = (selectedItem: string, selectedItemValue: boolean, setSelectedItem: (selectedItem: boolean) => void) => {
        setSelectedItem(!selectedItemValue);
        let settings = userSettings;
        settings[selectedItem] = !selectedItemValue;
        UserSettings.update(settings);
    }
    
    const getLastPossibleCuttoffDateForArchiveYear = () => {
        const yesterday : Date = new Date; // starts as todays date
        yesterday.setDate(yesterday.getDate() - 1);    // this sets it to yesterdays date

        const yesterdayFormatted = [    // 'YYYY-MM-DD'
            yesterday.getFullYear().toString(),
            (yesterday.getMonth() + 1).toString().padStart(2, '0'),
            yesterday.getDate().toString().padStart(2, '0')
        ].join('-');

        // if yesterday is after January 15th, the cutoff will be January 15th
        if (yesterdayFormatted > `${(archiveYearValue + 1).toString().padStart(4, '0')}-01-15`) {
            return `${(archiveYearValue + 1).toString().padStart(4, '0')}-01-15`;
        }
        return yesterdayFormatted;
    };

    const [showEndOfYearModal, setShowEndOfYearModal] = React.useState(false);
    const [cutoffDateValue, setCutoffDateValue] = React.useState<null | string>(null);
    const [archiveYearValue, setArchiveYearValue] = React.useState(0);
    const [endOfYearValidationError, setEndOfYearValidationError] = React.useState<string | null>();
    const [archiveYearEditable, setArchiveYearEditable] = React.useState(false);
    const [waitingForEOYStatus, setWaitingForEOYStatus] = React.useState(false);
    const [endOfYearModalView, setEndOfYearModalView] = React.useState(MODAL_VIEW.DEFAULT);
    const [endOfYearStatusMessage, setEndOfYearStatusMessage] = React.useState<string>();

    const handleCutoffDateChange = (dateValue: string) => {
        if (endOfYearValidationError) { setEndOfYearValidationError(null); }    // reset error so new entry can be attempted
        setCutoffDateValue(dateValue);
    };
    
    const handleArchiveYearChange = (archiveYear: string) => {
        if (endOfYearValidationError) { setEndOfYearValidationError(null); }    // reset error so new entry can be attempted

        if (archiveYear.length > 4) { return; } // restricts the input to a max length of 4 characters

        let convertedArchiveYear;
        if (archiveYear === '') {
            convertedArchiveYear = 0;
        } else {
            convertedArchiveYear = parseInt(archiveYear);
        }

        setArchiveYearValue(convertedArchiveYear);
    }

    const startEndOfYearProcess = () => {
        setWaitingForEOYStatus(true);

        const endOfYearArchiveData = { cutoffDate: cutoffDateValue, archiveYear: archiveYearValue };

        axios.post(`${process.env.REACT_APP_API_URL}/api/pto/startEndOfYearArchive`,
        endOfYearArchiveData,
        AxiosConfig.configValue('min'))
        .then (response => {
            if (!response.data.Error.success) {
                setEndOfYearStatusMessage('There was an error starting the end of year archive, please try again.');
            }

            if (response.data.ptoEndOfYearArchiveStarted) {
                setEndOfYearStatusMessage('The end of year archive is in progress, check your notifications for the process status.');
            }
            
            notificationStore.getNotifications(props.userId);
        }).catch(error => {
            setEndOfYearStatusMessage('There was an error starting the end of year archive, please try again.');
        }).finally(() => { });

        setEndOfYearModalView(MODAL_VIEW.STATUS);
        setWaitingForEOYStatus(false);   
    };

    const validateInputFields = () => {      
        if (cutoffDateValue == null || cutoffDateValue === '') { setEndOfYearValidationError('A valid cutoff date needs to be entered.'); return; }
        if (archiveYearValue == null || archiveYearValue <= 0) { setEndOfYearValidationError('A valid archive year was not provided.'); return; }
        
        const today = [ // 'YYYY-MM-DD'
            new Date().getFullYear().toString(),
            (new Date().getMonth() + 1).toString().padStart(2, '0'),
            new Date().getDate().toString().padStart(2, '0')
        ].join('-');

        if (cutoffDateValue >= today) {
            setEndOfYearValidationError('The cutoff date needs to be set to before today\'s date.');
            return;
        } else if (cutoffDateValue > getLastPossibleCuttoffDateForArchiveYear()) {
            setEndOfYearValidationError(`The cutoff date needs to be on or before January 15th, ${archiveYearValue + 1}.`);
            return;
        } else if (cutoffDateValue.substring(0, 4) < archiveYearValue.toString().padStart(4, '0')) {
            setEndOfYearValidationError(`The cutoff date needs to be in or after ${archiveYearValue}.`);
            return;
        }

        setEndOfYearModalView(MODAL_VIEW.WARNING);
    };

    return (
        <div>
            <div className="d-inline-flex flex-row">
                <div style={{ marginLeft: 20, paddingTop: 5 }} className="flex-shrink-1 flex-row justify-content-between ml-auto w-200">
                    <div className='d-inline-flex'>
                        <SearchInput wrapperClassName="w-300 " onChange={(e: any) => setSearchValue(e.target.value)} value={searchValue} />
                    </div>
                    <div className='d-inline-flex w-220 pto-checkboxes' >
                        <Checkbox label="Show Inactive" isChecked={showInactive} onChange={() => handleOptionSelect("showInactive", showInactive, setShowInactive)} />
                    </div>
                    <div className='d-inline-flex w-220 pto-checkboxes'>
                        <Checkbox label="Display Zeros" isChecked={displayZeros} onChange={() => handleOptionSelect("displayZeros", displayZeros, setDisplayZeros)} />
                    </div>
                    <div className='d-inline-flex pto-checkboxes'>
                        <Checkbox label="Only Requested" isChecked={showOnlyPending} onChange={() => handleOptionSelect("showOnlyPending", showOnlyPending, setShowOnlyPending)} />
                    </div>
                    {shouldAllowAccess('HR:ADMIN') && (
                        <div className='d-inline-flex pto-checkboxes'>
                            <Button variant='light' className='bg-success text-white' onClick={() => { setShowEndOfYearModal(true); setEndOfYearModalView(MODAL_VIEW.INPUT); }} disabled={reference?.endOfYear?.LastArchivedYear ? false : true }>
                                <div className='pto-end-of-year-button-wrapper'>
                                    <span className="material-icons-outlined">archive</span>
                                    <div>End of Year</div>
                                </div>
                            </Button>
                        </div>
                    )}
                    {/* <div className='tt-div d-inline-flex'>
                        <Tooltip name="TT-PTO-Settings" />
                    </div> */}
                    <div className='tt-div d-inline-flex'>
                        <OverlayTrigger trigger={['hover', 'focus']} placement='right' overlay={
                            <Popover id={'pto-admin-information-popover'} className='pto-admin-info-icon-popover'>
                                <Popover.Title as='h2'>PTO Options</Popover.Title>
                                <Popover.Content>
                                    <h6>Show Inactive</h6>
                                    <p><strong>Select</strong> to show inactive employees in addition to the active employees in the reporting</p>
                                    <h6>Display Zeros</h6>
                                    <p><strong>Select</strong> to choose whether items that have only a 0 will be displayed or not</p>
                                    <h6>Show Only Requested</h6>
                                    <p><strong>Select</strong> to only show employees with requested hours pending</p>
                                    {shouldAllowAccess('HR:ADMIN') && (
                                        <>
                                            <h6>End of Year Archiving</h6>
                                            <p><strong>Click Button</strong> to start the archiving process for PTO</p>                                        
                                        </>
                                    )}
                                </Popover.Content>
                            </Popover>
                        }>
                            <span className="material-icons pto-admin-info-icon">info</span>
                        </OverlayTrigger>
                    </div>
                </div>
            </div>
            {/* End Header */}
            {
                loading &&
                <div className="d-flex justify-content-center align-items-center">
                    <Loader title="Loading PTO Data" />
                </div>
            }
            <div className="d-flex flex-column">
                {!loading && reference.states
                    .filter((s: { id: number, name: string }) => states.findIndex((s2: any) => s2.value === s.id) > -1)
                    .map((state: { id: number, name: string }) => {
                        return (
                            <PTOStateCollapse
                                state={state}
                                profitCenters={reference.profitCenters
                                    .filter((pc: any) => pc.stateId === state.id)
                                    .map((pc: any) => ({ label: pc.name, value: pc.id }))}
                                // profitCenters={profitCenter.filter((p: any) => 
                                //     reference.profitCenters.find((pc: any) => pc.id === p.value && pc.stateId === state.id))}
                                reference={reference}
                                key={state.id}
                                fromToDate={fromToDate}
                                includeInactive={showInactive}
                                searchValue={debouncedSearchValue}
                                showOnlyPending={showOnlyPending}
                                displayZeros={displayZeros}
                                setDisplayZeros={setDisplayZeros}
                                expandState={expandState}
                                expandCity={reference.profitCenters.filter((pc: any) => pc.stateId === state.id).length < 2}
                                setExpandCity={setExpandCity}
                                expandDetail={expandDetail}
                                setExpandDetail={setExpandDetail}
                            />
                        )
                    })}
            </div>
            <Modal show={showEndOfYearModal} backdrop='static' onHide={() => setShowEndOfYearModal(false)} aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header>
                    <Modal.Title>Start PTO End of Year Process</Modal.Title>
                    <div>
                        <OverlayTrigger trigger={['hover', 'focus']} placement='right' overlay={
                            <Popover id={'pto-eoy-information-popover'} className='pto-admin-info-icon-popover'>
                                <Popover.Title as='h2'>End of Year Archiving</Popover.Title>
                                <Popover.Content>
                                    <h6>Year to Archive</h6>
                                    <p>The year to be archived, and used to calculate carry over amounts for the following year.</p>
                                    <h6>Cutoff Date</h6>
                                    <p>The last date to include during the archiving process.</p>                                    
                                </Popover.Content>
                            </Popover>
                        }>
                            <span className="material-icons pto-admin-info-icon">info</span>
                        </OverlayTrigger>
                    </div>
                </Modal.Header>
                {endOfYearModalView === MODAL_VIEW.INPUT && (
                    <>
                        <Modal.Body>
                            {endOfYearValidationError && (
                                <div className='pto-end-of-year-modal-error-message'>
                                    {endOfYearValidationError}
                                </div>
                            )}
                            {!endOfYearValidationError && (
                                <div className='pto-end-of-year-modal-error-placeholder' />
                            )}
                            <div className='pto-end-of-year-modal-field-wrapper'>
                                <Form.Label>Year to Archive:</Form.Label>
                                <Form.Control
                                    className='pto-end-of-year-field'
                                    type='number'
                                    value={archiveYearValue === 0 ? '' : archiveYearValue.toString()}
                                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleArchiveYearChange(event.target.value)}
                                    readOnly={!archiveYearEditable}
                                    onKeyDown={(event: React.KeyboardEvent<HTMLDivElement>) => ['e', 'E', '+', '-', '.'].includes(event.key) && event.preventDefault()}
                                />
                            </div>
                            <div className='pto-end-of-year-modal-field-wrapper'>
                                <Form.Label>Cutoff Date:</Form.Label>
                                <Form.Control
                                    className='pto-end-of-year-field'
                                    type='date'
                                    max={getLastPossibleCuttoffDateForArchiveYear()}
                                    value={cutoffDateValue || ''}
                                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleCutoffDateChange(event.target.value)}                                
                                />
                            </div>                    
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant='light' className='action-text-danger' onClick={() => { setShowEndOfYearModal(false); setCutoffDateValue(null); setEndOfYearValidationError(null); setEndOfYearModalView(MODAL_VIEW.DEFAULT); }}>
                                <div className='pto-end-of-year-button-wrapper'>
                                    <span className="material-icons-outlined">close</span>
                                    <div>Cancel</div>
                                </div>
                            </Button>
                            <Button variant='light' className='action-text bg-success text-white' onClick={() => { validateInputFields(); }} disabled={endOfYearValidationError ? true : false}>
                                <div className='pto-end-of-year-button-wrapper'>
                                    <span className="material-icons">play_arrow</span>
                                    <div>Start</div>
                                </div>
                            </Button>
                        </Modal.Footer>                
                    </>
                )}
                {endOfYearModalView === MODAL_VIEW.WARNING && (
                    <>
                        <Modal.Body>
                            <div className='pto-end-of-year-icon-container'>
                                <span className="material-icons-outlined pto-end-of-year-warning-icon">warning</span>
                                Warning
                            </div>
                            <br />
                            <div>- Ensure that all PTO requests are approved and all accruals have been entered for {archiveYearValue.toString()}.</div>
                            <br />
                            <div>- Once archived, no PTO requests will be able to be made for dates that fall within archived period.</div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant='light' className='action-text-danger' onClick={() => { setEndOfYearModalView(MODAL_VIEW.INPUT); }} disabled={waitingForEOYStatus}>
                                <div className='pto-end-of-year-button-wrapper'>
                                    <span className="material-icons-outlined">close</span>
                                    <div>Cancel</div>
                                </div>
                            </Button>
                            <Button variant='light' className='action-text bg-success text-white' onClick={() => startEndOfYearProcess()} disabled={waitingForEOYStatus}>
                                <div className='pto-end-of-year-button-wrapper'>
                                    <span className="material-icons">play_arrow</span>
                                    <div>Start</div>
                                </div>
                            </Button>
                        </Modal.Footer>
                    </>
                )}
                {endOfYearModalView === MODAL_VIEW.STATUS && (
                    <>
                        <Modal.Body>
                            <div className='pto-end-of-year-icon-container'>
                                <span className="material-icons-outlined pto-end-of-year-warning-icon">pending_actions</span>
                                Status
                            </div>
                            <br />
                            <div>{endOfYearStatusMessage}</div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button
                                variant='primary'
                                onClick={() => {
                                    setShowEndOfYearModal(false);
                                    setEndOfYearModalView(MODAL_VIEW.DEFAULT);
                                    setCutoffDateValue(null);
                                    setEndOfYearStatusMessage('');
                                }}
                            >Ok</Button>
                        </Modal.Footer>
                    </>
                )}
            </Modal>                             
        </div>
    )
}

const mapStateToProps = (state: AppState) => ({ 
    userId: state.user.userId,
});

export default connect(mapStateToProps)(PTOAdministration);